window.customAutoCompleteCancelToken = axios.CancelToken;
window.customAutoCompleteCancelSource = customAutoCompleteCancelToken.source();


//provides a custom autocomplete behavior by calling the provided url once the user has paused typing in the given element.
function customAutoComplete(el, url, config, callback) {
    if (!callback && config instanceof Function) callback = config;  //This line lets us skip passing in config if we want.
    if (!config) config = {};
    
    if (el && el.addEventListener) {
        var timeout = null;
        el.addEventListener('keyup', function (event) {
            if (timeout) window.clearTimeout(timeout);
            if (window.customAutoCompleteCancelSource) window.customAutoCompleteCancelSource.cancel('Canceled for new request');
            if (event.keyCode === 13) return; //callback(null);
            window.customAutoCompleteCancelSource = customAutoCompleteCancelToken.source();
            config.cancelToken = window.customAutoCompleteCancelSource.token;
            if (el.value.length < 3)
                callback(null);
            else {
                timeout = window.setTimeout(function () {
                    axios.get(url + el.value, config) //TODO: make this do a string replace instead?
                        .then(callback)
                        .catch(function () { }); //TODO: other error handling.  This is here to swallow cancelation.
                }, 300);
            }
        });
        //TODO: some logic to handle 'enter'
    }
}

function customAutoCompleteWithPartial(el, url, callback) {
    customAutoComplete(el, url,
        {
            headers: { 'Accept': 'text/html' } 
        },
        callback);
}